'use strict';

var gl_modAnimationList_v4_fpsCounter = null;
var modAnimationList_v4 = function( options ) {

    this.FPS_COUNTER = true;

    this.init( options );

};

modAnimationList_v4.prototype.init = function( options ) {
    var defaults = {
        onStart: function() {},        // pirms sāk animāciju
        onStop: function() {},        // kad 100% beidz animāciju; iepriekš onFinish
        onRestart: function() {},    // ja ir playing un izsauc stop un pēctam atkal play;

        onStopping: function() {},        // kad daļēji beidz animāciju - kad kāds no animācijas saraksta jau ir beidzies; un vairs nevar palaist parasto restart;
        onMultiplying: function() {},    //

        onCallStop: function( force ) {},    // kad tiek izsaukts stop;
        onCallRestart: function() {},        // kad tiek izsaukts restart;
        onStopCancel: function( force ) {},    // kad tiek atcelts stop;

        onLoop: function() {},    // kad tiek atcelts stop;


        timeFactor: 1                    // paātrināt / palēnināt;
    };

    this.options = $.extend( {},
        defaults,
        options || {} );


    this.isPlaying = false;        // vai animācija pašlaik notiek;
    this.isStopping = false;    // vai animācija tiek apturēta;
    this.isRestarting = false;    // vai animācija tiek restartēta;
    this.isFroceStop = false;    // vai animācija tiek apturēta ar force;
    this.status = 'waiting';

    this.timeFactor = this.options.timeFactor;


    this.listIdx = 0;
    this.list = {};

    this.stackIdx = 0;
    this.stack = {};
    this.currentDuration = 0;

    this.playingCount = 0;
    this.stoppedCount = 0;
};


modAnimationList_v4.prototype.setTimeFactor = function( timeFactor ) {
    // 1 ir parasts laiks; 0.5 ir 2x ātrāks; 2 ir 2x lēnāks;
    this.timeFactor = timeFactor;
};


modAnimationList_v4.prototype.add = function( animation ) {
    this.list[ this.listIdx ] = animation;
    animation.setList( this, this.listIdx );

    ++this.listIdx;
};

modAnimationList_v4.prototype.update = function() {
    $.each( this.list, function( listIdx, animation ) {
        animation.update();
    } );
};


modAnimationList_v4.prototype.play = function() {
    if (this.isPlaying) {
        this.playAgain();
        return;
    }

    this.prepareAnimation();
    //return;

    this.stoppedCount = 0;
    this.isPlaying = true;
    this.isStopping = false;
    this.isRestarting = false;
    this.isFroceStop = false;
    this.status = 'playing';
    this.setAnimationAction('playing');

    this.options.onStart();


    if (this.FPS_COUNTER) {
        if (gl_modAnimationList_v4_fpsCounter) {
            this.FPS_COUNTER = false;
        } else {
            gl_modAnimationList_v4_fpsCounter = new fpsCounter( $('.fpsCounter'), $('.fpsCounterMin'), $('.fpsCounterMax'), $('.fpsCounterAVG') );
            //gl_modAnimationList_v4_fpsCounter.selflist = this;
        }
    }

    this.playElem = $({
            animValue: 0
        });
    this.playLoop();
};

modAnimationList_v4.prototype.stop = function( force ) {
    if (this.isPlaying) {
        // palaižot stop - atceļam arī restart;
        this.isRestarting = false;

        this.isStopping = true;
        this.isFroceStop = force || false;
        this.status = 'stopping';
        this.setAnimationAction('stopping');

        if (force && this.FPS_COUNTER) {
            if (gl_modAnimationList_v4_fpsCounter) {
                gl_modAnimationList_v4_fpsCounter = null;
                this.FPS_COUNTER = false;
            }
        }

        this.options.onCallStop( this.isFroceStop );
    }
};
modAnimationList_v4.prototype.finish = function() {
    this.stop();
};

modAnimationList_v4.prototype.restart = function() {
    if (this.isPlaying) {
        // ja vēl nav paspēts neko apturēt, tad turpinam animāciju itkā nav veikts stop;
        if (!this.stoppedCount) {
            if (this.isStopping) {
                this.options.onStopCancel( this.isFroceStop );
            }

            this.isStopping = false;
            this.isRestarting = false;
            this.isFroceStop = false;
            this.isPlaying = true;
            this.status = 'playing';
            this.setAnimationAction('playing');
            return;
        }

        this.isStopping = true;
        this.isRestarting = true;
        this.status = 'restarting';
        //this.setAnimationAction('restarting'); - savādāk visi nerestartējas;
        this.setAnimationAction('stopping');
        /* if (!this.isFinishing) {
            this.isStopping = true;
        } */

        this.options.onCallRestart();
        return;
    }
    this.play();
};

modAnimationList_v4.prototype.playAgain = function() {
    if (this.isStopping && !this.isRestarting) {
        this.restart();
    }

    this.doMultiply();
};

modAnimationList_v4.prototype.doMultiply = function() {
    const self = this;

    // varbūt klonējam šo list un atskaņojam vēlreiz?
    // nē tad nebūs eventi pareizi kad galīgi beidzas;

    $.each( this.list, function( listIdx, animation ) {
        if (!animation.hasAnimation) {
            return true;
        }
        if (!animation.canMultiply || !animation.multiply) {
            return true;
        }

        //console.log('animation.multiply', animation.options.randomizeStart);
        //animation.options.randomizeStart

        const clone = animation.clone();
        if (animation.options.randomizeStart) {
            self.doRandomizeStart(animation.options.randomizeStart, clone);
            //console.log('clone.options', clone.options, clone.startOpts);
        }
        clone.setList( self, listIdx, true );

        self.stack[ self.stackIdx ] = clone;
        clone.setStack( self.stackIdx );
        ++self.stackIdx;
        ++self.playingCount;

        //console.log('clone.options', clone.options);

        // duration no šī nemainās, tik būs out of sync;
        //self.currentDuration = Math.max(animation.getDuration(), self.currentDuration);

        //console.log('animation.multiply reset:');
        /* if (animation.options.randomizeStart) {
            self.doRandomizeStart(animation.options.randomizeStart, clone);
            //console.log('clone.options', clone.options, clone.startOpts);
        } */
        clone.reset();
    } );
};

modAnimationList_v4.prototype.doRandomizeStart = function(randomizeStart, clone) {
    //{translate:{x:[true,-100,100]}};
    //clone.options.animdata.startOpts
    /* if (clone.options.animdata.startOpts) {
        mergeRandObj(randomizeStart, clone.options.animdata.startOpts);
        mergeRandObj(randomizeStart, clone.startOpts);
        console.log(clone.animList);
        if (clone.animList[0]) {
            if (clone.animList[0].list[0]) {
                if (clone.animList[0].list[0].value) {
                    if (clone.animList[0].list[0].value.x) {
                        clone.animList[0].list[0].value.x.from = getRnd(randomizeStart.translate.x[1], randomizeStart.translate.x[2]);
                        clone.animList[0].list[0].value.y.from = getRnd(randomizeStart.translate.x[1], randomizeStart.translate.x[2]);
                    }
                }
            }
        }
    } */
};

modAnimationList_v4.prototype.setAnimationAction = function( action ) {
    $.each( this.stack, function( stackIdx, animation ) {
        animation.setAction( action );
    } );
};


modAnimationList_v4.prototype.prepareAnimation = function() {
    const self = this;

    this.currentDuration = 0;

    this.playingCount = 0;
    this.stackIdx = 0;
    this.stack = {};


    $.each( this.list, function( listIdx, animation ) {
        // Ja šai animācijai nekas nemainās tad šo skipojam un nepievienojam sarakstā;
        // varbūt tomēr vajadzēs pievienot sarakstā ja vajag citus action?
        if (!animation.hasAnimation) {
            animation.reset();
            return true;
        }

        self.stack[ self.stackIdx ] = animation;
        animation.setStack( self.stackIdx );
        ++self.stackIdx;
        ++self.playingCount;

        self.currentDuration = Math.max(animation.getDuration(), self.currentDuration);

        animation.reset();
    } );
};

modAnimationList_v4.prototype.togglePause = function( pause ) {
    this.paused = pause == undefined ? !this.paused : pause;

    if (this.playElem) {
        this.playElem.stop();
    }
    //console.log( 'this.paused', this.paused);
};

modAnimationList_v4.prototype.playLoop = function() {
    const self = this;

    this.options.onLoop(this);

    if (this.paused) {
        setTimeout(function() {
            self.playLoop();
        }, 500);

        this.playElem.stop();
        return true;
    }

    if (this.playingCount <= 0) {
        this.playFinish();
        return false;
    }

    this.prevStep = 0;
    this.nowStep = 0;
    this.playElem[0].animValue = 0;

    $.when(

        this.playElem.animate({
            animValue: this.currentDuration
        }, {
            duration: this.currentDuration * this.timeFactor,
            easing: 'linear',
            step: function( now, tween ) {

                self.nowStep = now - self.prevStep;
                self.prevStep = now;
                if (self.FPS_COUNTER && gl_modAnimationList_v4_fpsCounter) {
                    gl_modAnimationList_v4_fpsCounter.step()
                }

                // palaižam visām animācijām nākošo soli;
                $.each( self.stack, function( stackIdx, animation ) {
                    animation.step( self.nowStep );
                } );

                if (self.isFroceStop) {
                    self.playingCount = 0;
                    $( this ).stop();
                }

                if (self.playingCount <= 0) {
                    $( this ).stop();
                }
            }
        }).promise()

    ).then(function() {
        setTimeout(function() {
            self.playLoop();
        }, 10);
    });

    return true;
};

modAnimationList_v4.prototype.playFinish = function() {
    this.isPlaying = false;
    this.isStopping = false;
    this.isFroceStop = false;

    this.playingCount = 0;
    this.stoppedCount = 0;

    if (this.isRestarting) {
        this.options.onRestart();
        this.isRestarting = false;
        this.play();
        return;
    }

    /* if (this.FPS_COUNTER) {
        if (gl_modAnimationList_v4_fpsCounter) {
            gl_modAnimationList_v4_fpsCounter = null;
        }
    } */
    this.FPS_COUNTER = true;

    this.status = 'waiting';
    this.setAnimationAction('finish');

    this.options.onStop();
    this.removeClones();
};

modAnimationList_v4.prototype.removeClones = function() {
    const self = this;

    $.each( this.stack, function( stackIdx, animation ) {
        if (!animation.isClone) {
            return true;
        }

        delete self.stack[ stackIdx ];
        animation.remove();
    } );
};



modAnimationList_v4.prototype.itemFinished = function( listIdx, stackIdx, animation ) {
    --this.playingCount;
    ++this.stoppedCount;

    if (animation.isClone && animation.autoRemoveClone) {
        delete this.stack[ stackIdx ];
        animation.remove();
    } else if (animation.autoHide) {
        animation.hide();
    }

    this.options.onStopping();
};

modAnimationList_v4.prototype.itemRestarted = function( listIdx, stackIdx, animation ) {
    ++this.playingCount;
    --this.stoppedCount;

    if (this.stoppedCount <= 0) {
        this.options.onRestart();
    }
};

function getRnd(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function mergeRandObj(randomObj, targetObj) {
    //{translate:{x:[true,-100,100]}};
    //targetObj
    if (randomObj) {
        $.each(randomObj, function(key, value) {
            if (Array.isArray(value)) {
                if (value.length == 3 && value[0] === true) {
                    if (typeof targetObj[key] == 'undefined') {
                        return;
                    }
                    targetObj[key] = getRnd(value[1], value[2]);
                }
            } else if (typeof value === 'object') {
                if (typeof targetObj[key] == 'undefined') {
                    return;
                }
                mergeRandObj(value, targetObj[key]);
            }
        } );
    }

}


window.modAnimationList_v4 = modAnimationList_v4;